/**
 * Giriş doğrulamasında kişisel verilerin işlenmesi — aydınlatma metni (03.11.2026).
 * Kod ekranında (SignInPage, 2. adım) "Aydınlatma metni" bağlantısıyla açılır. Hukuk/İK metni düzeltirse YALNIZ bu
 * dosya değişir. Kaynak taslak: Claude Docs "Fedora SMS doğrulaması — duyuru ve aydınlatma metni".
 * Doğruluk: kod Redis'te yalnız HMAC özeti olarak gün sonuna kadar tutulur (services/giris_guvenligi.py); SMS NetGSM
 * üzerinden gider; olay kaydı IP + tarayıcı + sonuç tutar. Metni değiştirirken bu gerçeklerle çelişmesin.
 */
export const AYDINLATMA_BASLIK = 'Giriş doğrulamasında kişisel verilerin işlenmesi';

export const AYDINLATMA_MADDELERI = [
  ['Veri sorumlusu', 'ATM Point A.Ş.'],
  ['İşlenen veriler', 'Cep telefonu numaranız; giriş tarihi ve saati; IP adresi; tarayıcı bilgisi; doğrulamanın sonucu.'],
  ['Amaç', "Fedora'ya girişte kimliğinizi doğrulamak, hesabınızın başkası tarafından kullanılmasını önlemek ve "
    + 'bilgi güvenliğini sağlamak.'],
  ['Hukuki sebep', '6698 sayılı KVKK m.5/2-c (iş sözleşmesinin ifası), m.5/2-ç (veri güvenliğine ilişkin hukuki '
    + 'yükümlülük, KVKK m.12) ve m.5/2-f (meşru menfaat).'],
  ['Toplama yöntemi', 'Telefon numaranız personel kayıtlarınızdan alınır; giriş bilgileri giriş sırasında elektronik '
    + 'ortamda otomatik olarak kaydedilir.'],
  ['Aktarım', 'Doğrulama kodu, telefon numaranızla birlikte yalnız SMS hizmet sağlayıcımıza (yurt içi) iletilir.'],
  ['Saklama', 'Doğrulama kodu açık hâliyle saklanmaz; özeti gün sonunda silinir.'],
  ['Haklarınız', 'KVKK m.11 kapsamındaki haklarınız için İnsan Kaynakları birimine başvurabilirsiniz. Numaranız '
    + 'değiştiyse ya da yanlışsa Bilgi Teknolojileri birimine bildirin.'],
];
